import { useEffect, useState } from "react";

import { HeaderWithNextButtonLayout } from "@components";
import { Documents, UploadDocuments } from "./components";

import { useAttachedFiles } from "@hooks/HRM/employee/useAttachedFiles";

export interface AttachedFilesPropsType {
  id: number | null;
  changeActiveTab: (arg: number) => void;
  isProfileDisabled: boolean;
}

export default function AttachedFiles({
  id,
  changeActiveTab,
  isProfileDisabled,
}: AttachedFilesPropsType) {
  const [employeeFiles, setEmployeeFiles] = useState({});

  const {
    createAttachedFile,
    removeAttachedFile,
    attachedFiles,
    createAttachedFileRequestOngoing,
    getAttachedFilesRequestOngoing,
    deleteAttachedFileRequestOngoing,
  } = useAttachedFiles(id);

  // there is an issue in the attached files. it keeps previous user data. thats why this step taken
  useEffect(() => {
    setEmployeeFiles(attachedFiles);
  }, [attachedFiles]);

  return (
    <HeaderWithNextButtonLayout
      title="EMPLOYEE.ATTACHED_FILES.HEADING"
      subtitle="EMPLOYEE.ATTACHED_FILES.DESCRIPTION"
      action={() => changeActiveTab(2)}
    >
      <Documents
        attachedFiles={employeeFiles}
        createAttachedFile={createAttachedFile}
        removeAttachedFile={removeAttachedFile}
        isProfileDisabled={isProfileDisabled}
      />
      <UploadDocuments
        attachedFiles={employeeFiles}
        createAttachedFile={createAttachedFile}
        removeAttachedFile={removeAttachedFile}
        getAttachedFileRequestOngoing={getAttachedFilesRequestOngoing}
        updateAttachedFileRequestOngoing={createAttachedFileRequestOngoing}
        deleteAttachedFileRequestOngoing={deleteAttachedFileRequestOngoing}
        isProfileDisabled={isProfileDisabled}
      />
    </HeaderWithNextButtonLayout>
  );
}
